import React from 'react';

export interface GsLayoutProps {
  header: React.ReactNode;
  sidebar?: React.ReactNode;
  mobileNav?: React.ReactNode;
  children: React.ReactNode;
}

export function GsLayout({ header, sidebar, mobileNav, children }: GsLayoutProps) {
  const mainPadBottom = mobileNav ? 'pb-20 md:pb-0' : '';

  return (
    <div className="flex h-screen overflow-hidden bg-white dark:bg-slate-900">
      {sidebar}
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        {header}
        {/* bg-[#fbfbfb] light — dark:bg-slate-900 dark mode */}
        <main
          className={`min-h-0 flex-1 overflow-auto bg-[#fbfbfb] dark:bg-slate-900 px-4 py-5 sm:px-6 sm:py-6 ${mainPadBottom}`}
        >
          {children}
        </main>
      </div>
      {mobileNav && (
        <div className="fixed bottom-0 left-0 right-0 z-50 flex justify-around border-t border-slate-200 bg-white dark:bg-slate-950 dark:border-slate-800 p-3 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] md:hidden">
          {mobileNav}
        </div>
      )}
    </div>
  );
}
